import { Component, ContentChild, Input, Output, EventEmitter, TemplateRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Modal } from '../../modal';

@Component({
    standalone: false,
    selector: 'abs-account-settings',
    template: `
        <ng-template #defaultDeleteConfirmTemplate>
            <p>{{ 'GLOBAL.SETTINGS.ACCOUNT.DELETE.ARE_YOU_SURE' | translate }}</p>
        </ng-template>

        <ng-template #deleteModalContent>
            <ng-container *ngTemplateOutlet="deleteConfirmContent || defaultDeleteConfirmTemplate"></ng-container>
        </ng-template>

        <ng-template #deleteButtonsTemplate>
            <ion-button color="danger" (click)="confirmDelete()">{{ 'GLOBAL.YES' | translate }}</ion-button>
            <ion-button (click)="cancelDelete()">{{ 'GLOBAL.NO' | translate }}</ion-button>
        </ng-template>

        <div class="button-row">
            <ion-button (click)="triggerLogout()">{{ 'GLOBAL.LOGIN.BUTTONS.LOGOUT' | translate }}</ion-button>
            <ion-button color="danger" (click)="showDeleteModal()">
                {{ 'GLOBAL.SETTINGS.ACCOUNT.DELETE.BUTTON' | translate }}
            </ion-button>
        </div>

        <h2>{{ 'GLOBAL.SETTINGS.DEVICES.TITLE' | translate }}</h2>
        <abs-devices></abs-devices>
    `,
    styles: [
        `
            .button-row {
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                margin-bottom: 8px;
            }
        `
    ]
})
export class AbsAccountSettingsComponent {
    @Input({ required: true }) logout!: () => void;
    @Output() deleteAccountConfirmed = new EventEmitter<void>();

    @ContentChild('deleteConfirmContent') deleteConfirmContent: TemplateRef<any>;
    @ViewChild('deleteModalContent') deleteModalContent: TemplateRef<any>;
    @ViewChild('deleteButtonsTemplate') deleteButtonsTemplate: TemplateRef<any>;

    constructor(
        private modal: Modal,
        private translateService: TranslateService
    ) {}

    triggerLogout() {
        this.logout();
    }

    showDeleteModal() {
        this.modal.show({
            props: {
                contentTemplate: this.deleteModalContent,
                buttonsTemplate: this.deleteButtonsTemplate,
                buttonsDirection: 'horizontal',
                title: this.translateService.instant('GLOBAL.SETTINGS.ACCOUNT.DELETE.TITLE')
            }
        });
    }

    confirmDelete() {
        this.modal.dismiss();
        this.deleteAccountConfirmed.emit();
    }

    cancelDelete() {
        this.modal.dismiss();
    }
}
